// extracted by mini-css-extract-plugin
export default {"container":"MenuList_container__zDWAX"};